import { useEffect } from 'react';
import { useAtom } from 'jotai';
import useRudderStackTrack from '../../../../hooks/useRudderStackTrack';
import { disableTrackEventsAtom } from '../Filter/filterStore';

export const useBoatDisplayedTrack = (routerReady: boolean, areBoatsLoading: boolean, searchHeadline: string) => {
  const rudderTrack = useRudderStackTrack();
  const [disableTrackEvents, setDisableTrackEvents] = useAtom(disableTrackEventsAtom);

  useEffect(() => {
    if (areBoatsLoading || !routerReady || disableTrackEvents) return;

    rudderTrack('js_boats_displayed_search', {
      text_displayed: searchHeadline,
    });

    setDisableTrackEvents(false);
  }, [searchHeadline, routerReady]);
};
